import { render, staticRenderFns } from "./DeceasedIcon.vue?vue&type=template&id=108ad9fb&"
import script from "./DeceasedIcon.vue?vue&type=script&lang=js&"
export * from "./DeceasedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports